module.exports = __webpack_public_path__ + "img/beka80.95ea5a78.jpg";